// Axios
import Axios from "./axios";

export const fetchTestimonialDetail = (id) => {
  return new Promise((resolve, reject) => {
    const data = Axios.get(`/workshopTestimonial/${id}`, {
      headers: {
        "access-token": localStorage.getItem("access_token"),
      },
    });
    resolve(data);
  });
};
